// eslint-disable-next-line import/no-cycle
import { IPostItem } from 'Models';
import CONFIG from 'Config';
import { request } from '../request';
import { IListResponseData } from '../types';

export function getHomePageArticles(limit?: string): Promise<IListResponseData<IPostItem>> {
  return request<IListResponseData<IPostItem>>(`${CONFIG.urls.cms}/?o=featured-hp&limit=${limit || 2}&parent=learn`);
}
